import React from 'react';
import PropTypes from 'prop-types';
import MapListItem from './c/mapListItem/MapListItemConnector';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import CheckIcon from '@material-ui/icons/CheckCircleOutline';
import SovosTooltip from 'shared/sovos-tooltip/SovosTooltip';

const errorIconStyle = { color: 'red', fontSize: 20 };
const checkIconStyle = { color: '#00cc00', fontSize: 20 };

const showRemainingRequiredFields = (mappedRequiredFields, requiredFields) => {
  let remainingFields = [];
  requiredFields.map(reqField => {
    if(!mappedRequiredFields.some( mappedReqField => reqField.name === mappedReqField.targetField)){
      remainingFields.push(reqField);
    }
  });
  return [
    <div key="requiredLabel">REQUIRED:<br /><br /></div>,
    remainingFields.map(field => <div key={ field.name }>{field.name}</div>)
  ];
};

const countRemainingRequiredFields = (mappedRequiredFields, requiredFields) => (`${requiredFields.length - mappedRequiredFields.length} Required Fields`);

const ColumnLists = ({ sourcesGroups, activeDivision, mappedRequiredFields, requiredFields }) => (
  <div className="map-columns__column-lists">
    <div className="map-columns__column-lists-headers">
      <h3>Input Data Columns</h3>
      <h3>Sovos System Columns</h3>
      {
        (mappedRequiredFields.length - requiredFields.length) !== 0 &&
        <SovosTooltip
          id="requiredFields"
          place="bottom"
          label={ showRemainingRequiredFields(mappedRequiredFields, requiredFields) }
          effect="solid"
          contentWidth={ 200 }
        >
          <div className="map-columns__column-lists-right-headers">
            <ErrorIcon className="map-columns__column-lists-right-headers__icon" style={ errorIconStyle }/>
            <h4  className="map-columns__column-lists-right-headers__error-label">
              { countRemainingRequiredFields(mappedRequiredFields, requiredFields) }
            </h4>
          </div>
        </SovosTooltip>
      }
      {
        (mappedRequiredFields.length - requiredFields.length) === 0 &&
        <div className="map-columns__column-lists-right-headers">
          <CheckIcon className="map-columns__column-lists-right-headers__icon" style={ checkIconStyle }/>
          <h4 className="map-columns__column-lists-right-headers__check-label">Required Fields Mapped</h4>
        </div>
      }
    </div>
    {
      sourcesGroups.map(group => (
        <span key={ group.identifier || 'no-groups' }>
          { group.identifier && <h4 className="map-columns__subgroup-subtitle">{ `Subgroup: ${group.identifier}` }</h4> }
          <ul>
            {
              group.columns.map(objectKey => (
                <li key={ `${activeDivision}_${objectKey}` }>
                  <MapListItem sourceName={ objectKey } subGroup={ group.identifier } activeDivision={ activeDivision } />
                </li>
              ))
            }
          </ul>
        </span>
      ))
    }
  </div>
);

ColumnLists.propTypes = {
  activeDivision: PropTypes.number,
  sourcesGroups: PropTypes.array.isRequired,
  mappedRequiredFields: PropTypes.array.isRequired,
  requiredFields: PropTypes.array.isRequired
};

ColumnLists.defaultProps = {
  activeDivision: 0
};

export default ColumnLists;



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/columnListsSlidingPanel/c/columnLists/ColumnLists.js